
export const BuyerPaymentCountQuery = new TypedDocumentString(`
    query BuyerPaymentCountQuery {
  buyerPaymentInvoiceCount {
    ...PaymentInvoiceDocCount
    __typename
  }
}
    fragment PaymentInvoiceDocCount on PaymentInvoiceDocCount {
  id
  payments
  quote
  toReview
  __typename
}`, {"hash":"b00f050ff7cbfe23fc8b82a7571e3edac407afcbcfa6c15356d5ccd6506596b3"});